"use client"
import styles from './NearMe.module.css';
import dynamic from "next/dynamic";
const SearchInput = dynamic(() => import("components/Search"));

const NearMe = () => {

  const searchTerms = [
    'Shops to rent near me',
    'Shop for rent near me',
    'Shops to let near me',
    'Units to rent near me',
    'Small units to rent near me',
    'Small shop to rent near me',
    'Cafe to rent near me',
    'Retail shops to rent near me',
    'Retail units to let near me',
    'Unit to rent near me',
    'Empty shops to rent near me',
    'Small cafe to rent near me',
    'Cafe for rent near me',
    'Empty shop for rent near me',
    'Units for rent near me',
    'Small shop for rent near me',
    'Rent a shop near me',
    'Shops for lease near me',
    'Council shops to rent near me',
    'Cheap shops to rent near me',
  ]

  return (
    <div className={styles.Wrapper}>
      <section className={styles.search}>
        <div className={styles.searchInner}>
          <h1>Shops to rent near me</h1>
          <p>Looking for nearby shops to rent? You’re in the right place.</p>
          <p>We have shops to rent big and small, so whatever you’re looking for we’ll have a shop for you.</p>
          <SearchInput
            settings={{
              category: 'ALL',
              type: 'PROPERTY',
            }}
            label={`Enter your location or postcode`}
            showLabel={false}
            showControls={false}
            showCategory={false}
            upperBackgroundColour={"#3C3C3C"}
            lowerBackgroundColour={"#3C3C3C"}
            showCurrentLocation={true}
          />
        </div>

      </section>
      <section className={styles.otherSearch}>
        <h2>People are also searching</h2>
        <ul>
          {searchTerms.map((term, index) => {
            return (
              <li key={term}>{term}</li>
            )
          })}
          
        </ul>
      </section>
    </div>
  )

}

export default NearMe;